/**
 * The error message deliberately thrown in a Next.js `routeChangeStart` handler
 * to cancel navigation. Shared with the Datadog `beforeSend` filter so a rename
 * cannot silently re-open Error Tracking noise.
 */
export const ROUTE_CHANGE_ABORTED_ERROR_MESSAGE = 'Route change aborted.'
